import { setUsrAppRefreshParams } from '@jfs/network'
import { Box, Loader, ModalDialogNew, ModBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/utils'
import { useNavigation } from '@react-navigation/core'
import { createStackNavigator } from '@react-navigation/stack'
import { useEffect, useState } from 'react'
import { StatusBar } from 'react-native'
import EmptyView from '../../comps/EmptyView'
import { useLazyApiData, useStores } from '../../data/store'
import { AppHeaderTransformer, extendAppSession } from '../../network/extendAppSession'
import { extendUserSession, HeaderTransformer } from '../../network/extendUserSession'
import { screenTransition } from '../../util/common'
import { UserManagment } from '../UserManagmentStack'

import {
  getFromStore,
  hasNotificationPermission,
  isMobile,
  isOsMobile,
  isSessionValid,
  routeNameMapping,
  safelyParseJSON,
  storeData,
  useWindowDimensions,
} from '../../util/util'
import { BillPaymentStack } from '../BillPaymentStack'
import NewDashboard from '../NewDashboard'
import Header from '../NewDashboard/Header'
import NewTab from '../NewTab'
import { navigationRef } from '../RootNav'
import { Routes } from '../routes'

import { Platform, StyleSheet } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import SettlementBankAccount from '../../screens/BankAccount/SettlementBankAccount'
import { RenderMidList } from '../../screens/Home/RenderMidList'
import { KYCConsentScreen } from '../../screens/KYCConsentScreen'
import ManageNotifications from '../../screens/NotificationSettings/ManageNotifications'
import EnterAmount from '../../screens/QRcodeV2/EnterAmount'
import GenerateQR from '../../screens/QRcodeV2/GenerateQR'
import QrPaymentStatus from '../../screens/QRcodeV2/QrPaymentStatus'
import Search from '../../screens/Search/'
import SettlementDetails from '../../screens/SettlementDetails/'
import Support from '../../screens/Support'
import TxnDetails from '../../screens/TxnDetails/'
import VideoView from '../../screens/VideoView/'
import VoiceBox from '../../screens/VoiceBoxNew'
import RentalHistory from '../../screens/VoiceBoxNew/RentalHistory'
const DashboardStackString = {
  search: 'search',
  video: 'video',
  dashboard: 'dashboard',
  txnsDownload: 'txns-download',
  settlementDownload: 'settlements-download',
}

const renderLoaderView = (isMob: boolean) => {
  return (
    <Box flex={1} backgroundColor="WHITE" justifyContent={'center'} alignItems="center">
      <Loader type="large" color={isMob ? 'PRIMARY' : 'BLUE'} />
      <Spacer size={20} />
      <TextNew fontSize={14} title="Loading Data... " color={isMob ? 'PRIMARY' : 'BLUE'} />
    </Box>
  )
}

const Stack = createStackNavigator()

const Dashboard = ({ route }: any) => {
  const {
    mid,
    getPermissionList,
    getAllMerchantMetaData,
    retrieveSplitStatusOnMid,
    selectedMname,
    returnJfsUserIdAfterLogin,
    merchantData,
    notAllowedUserPermission,
    userMobileNo,
    sessUsrAccessToken,
    sessUsrRefreshToken,
    sessAppAccessToken,
    sessAppRefreshToken,
    sessionData,
    getIsSmidAndSubMerchants,
    getMerchentConfig,
    loadInitials,
    hasSupersetPermission,
    reset,
    shouldEnableSettingForSuperset,
    setShowChatbotAwareness,
    sortedMerchants,
    mobileNumber,
  } = useStores((root) => ({
    mid: root?.user?.selectedMid,
    getPermissionList: root?.userManagement.getUserPermissions,
    getAllMerchantMetaData: root?.user?.getAllMerchantMetaData,
    retrieveSplitStatusOnMid: root?.user?.retrieveSplitStatusOnMid,
    selectedMname: root?.settings?.metaData?.selectedMercName,
    returnJfsUserIdAfterLogin: root.user.session.jfsUserId,
    merchantData: root.user.merchants,
    notAllowedUserPermission: root?.userManagement?.notAllowedUserPermission,
    userMobileNo: root?.settings?.metaData?.mobileNumber,
    sessUsrAccessToken: root?.user?.session?.userAccessToken,
    sessUsrRefreshToken: root?.user?.session?.userRefreshToken,
    sessAppAccessToken: root?.user?.session?.appAccessToken,
    sessAppRefreshToken: root?.user?.session?.appRefreshToken,
    sessionData: root.user.session,
    getIsSmidAndSubMerchants: root.user.fetchSubMerchants,
    getMerchentConfig: root.user.getMerchentConfig,
    loadInitials: root.user.loadInitials,
    hasSupersetPermission: root?.userManagement?.hasSupersetPermission(),
    reset: root?.reset,
    shouldEnableSettingForSuperset: root?.userManagement?.shouldEnableSettingForSuperset(),
    setShowChatbotAwareness: root?.settings?.metaData?.setShowChatbotAwareness,
    sortedMerchants: root?.user?.sortedMerchants,
    mobileNumber: root?.settings?.metaData?.mobileNumber,
  }))

  const { REACT_APP_ENABLE_SPLIT_FEATURE } = window?._env_ ?? {}
  console.log('REACT_APP_ENABLE_SPLIT_FEATURE::', typeof REACT_APP_ENABLE_SPLIT_FEATURE, REACT_APP_ENABLE_SPLIT_FEATURE)
  const splitEnabled = REACT_APP_ENABLE_SPLIT_FEATURE === 'true'
  const merchantList = sortedMerchants()
  const isLargeScreen = useIsLargeScreen()
  const isSmallDevice = isMobile(isLargeScreen)
  const mobileView = isMobile(!isSmallDevice)
  const [showMidList, setMidListVisible] = useState(false)
  useEffect(() => {
    setUsrAppRefreshParams(
      () => extendUserSession(userMobileNo, sessUsrAccessToken, sessUsrRefreshToken),
      HeaderTransformer,
      () => extendAppSession(sessAppAccessToken, sessAppRefreshToken),
      AppHeaderTransformer,
    )
  }, [sessAppAccessToken, sessAppRefreshToken, sessUsrAccessToken, sessUsrRefreshToken, userMobileNo])

  const params: any = route?.params
  const width = useWindowDimensions()
  const navigation: any = useNavigation()

  const [searchAllMerchants, { state: searchMerchantHandlerState }] = useLazyApiData(getAllMerchantMetaData)
  const [lazyLoadInitials, loadInitialsHandler] = useLazyApiData(loadInitials)

  useEffect(() => {
    if (!isOsMobile() && !!selectedMname && loadInitialsHandler?.state === 'fulfilled') {
      getFromStore('chatbotAwarenessShown')
        .then((res) => {
          if (!res || isNaN(res) || Number(res) < 5) {
            setShowChatbotAwareness(true)
            const count = !res || isNaN(res) ? 1 : Number(res) + 1
            storeData('chatbotAwarenessShown', count)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [loadInitialsHandler?.state, selectedMname, setShowChatbotAwareness])

  useEffect(() => {
    if (isOsMobile() && !!mobileNumber) {
      console.log('htag fetching key', `KYC_ACCEPTED-${mobileNumber}`)
      getFromStore(`KYC_ACCEPTED-${mobileNumber}`).then((KYC_ACCEPTED: any) => {
        try {
          if (!KYC_ACCEPTED) {
            navigationRef.reset({
              index: 0,
              routes: [
                {
                  name: 'kycConsentScreen' as never,
                },
              ],
            })
          }
        } catch (error) {
          console.log('failed to set KYC_ACCEPTED', error, '[settingsStr]', KYC_ACCEPTED)
        }
      })
    }
  }, [mobileNumber])

  const screenname = navigationRef.isReady() ? navigationRef?.getCurrentRoute()?.name : ''
  useEffect(() => {
    if (loadInitialsHandler?.state === 'fulfilled' && !hasSupersetPermission) {
      const notAllowedScreen = notAllowedUserPermission()
      if (navigationRef.isReady()) {
        const screenName = routeNameMapping[navigationRef.getCurrentRoute()?.name as keyof typeof routeNameMapping]
        if (screenName && notAllowedScreen.includes(screenName)) {
          if (!notAllowedScreen.includes(routeNameMapping[Routes.TRANSACTIONS])) {
            navigationRef.navigate(Routes.TRANSACTIONS)
          } else {
            navigationRef.navigate(Routes.SETTLEMENTS)
          }
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadInitialsHandler, screenname])

  useEffect(() => {
    if (searchMerchantHandlerState === 'rejected') {
      // TODO: logout if search all merchant api fails
      setTimeout(() => {
        reset()
        navigation.reset({
          index: 0,
          routes: [
            {
              name: Routes.LOGIN as never,
            },
          ],
        })
      }, 500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchMerchantHandlerState])

  const isMob = isMobile(isLargeScreen)
  useEffect(() => {
    if (
      mid?.length > 2 &&
      returnJfsUserIdAfterLogin?.length > 2
      // Whether the search merhant API has already been called
    ) {
      lazyLoadInitials(isMob, splitEnabled)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mid, returnJfsUserIdAfterLogin])

  useEffect(() => {
    if (!isOsMobile()) {
      try {
        const sessData = window?.localStorage.getItem('sessionData')
        const jfsUserId = window?.localStorage.getItem('jfsUserId')
        if (!sessData || sessData?.length < 0 || !jfsUserId || !isSessionValid(safelyParseJSON(sessData))) {
          navigation?.reset({
            index: 0,
            routes: [{ name: Routes.LOGIN }],
          })
        }
      } catch (e) {
        navigation?.reset({
          index: 0,
          routes: [{ name: Routes.LOGIN }],
        })
      }
    }
  }, [navigation])

  useEffect(() => {
    if (isOsMobile()) {
      // getMerchentConfig()
    }
  }, [getMerchentConfig])

  useEffect(() => {
    if (!isOsMobile()) {
      const sessData = window?.localStorage.getItem('sessionData')
      if (!sessData && !isSessionValid(sessionData)) {
        window.set_merchant_details_after_logout?.()
        navigation?.reset({
          index: 0,
          routes: [{ name: Routes.LOGIN }],
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData, sessAppAccessToken, sessUsrAccessToken])

  useEffect(() => {
    if (isOsMobile()) {
      console.log('isSessionValid::', sessionData, isSessionValid(sessionData))
      if (!isSessionValid(sessionData)) {
        navigation?.reset({
          index: 0,
          routes: [{ name: Routes.LOGIN }],
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessAppAccessToken, sessAppRefreshToken, sessUsrAccessToken, sessUsrRefreshToken, userMobileNo])

  useEffect(() => {
    if (!selectedMname && returnJfsUserIdAfterLogin?.length > 2 && merchantData?.length < 1) {
      searchAllMerchants(returnJfsUserIdAfterLogin)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [returnJfsUserIdAfterLogin, selectedMname])

  useEffect(() => {
    if (merchantData.length > 0 && !isOsMobile()) {
      const merchantList = merchantData.map((item) => item.mid)
      setTimeout(() => {
        console.log('Calling get_merchant_login_details with : ', returnJfsUserIdAfterLogin, userMobileNo, merchantList)
        window.get_merchant_login_details?.(returnJfsUserIdAfterLogin, userMobileNo, merchantList)
      }, 500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantData.length])

  useEffect(() => {
    hasNotificationPermission()
  }, [])

  const renderTabBarIfSmallScreen = width <= 550 || Platform.OS !== 'web'
  const initialRoute = params?.path

  const DashboardComponent = renderTabBarIfSmallScreen ? NewTab : NewDashboard

  return (
    <Box flex={1} paddingTop={Platform.OS === 'ios' ? 40 : 0} backgroundColor={'SECONDARY'}>
      <StatusBar barStyle="light-content" translucent={false} />
      <ModBox
        show={loadInitialsHandler?.state === 'rejected'}
        position={'absolute'}
        backgroundColor="WHITE"
        left={0}
        right={0}
        bottom={0}
        zIndex={150}
        top={0}>
        <Header hideSearchBar={true} path={''} onSearchResultClicked={() => {}} />
        <EmptyView
          onRetry={() => lazyLoadInitials(isMob, splitEnabled)}
          isLoading={false}
          error="An error has occoured while processing your request."
          shouldShowSwitchMerchant={merchantList?.length > 0}
          setMidListVisible={setMidListVisible}
        />
      </ModBox>
      <ModBox
        show={!selectedMname || !loadInitialsHandler.state || loadInitialsHandler?.state === 'pending'}
        position={'absolute'}
        backgroundColor="WHITE"
        left={0}
        right={0}
        bottom={0}
        zIndex={100}
        top={0}>
        {renderLoaderView(isOsMobile())}
      </ModBox>
      <Stack.Navigator
        initialRouteName={DashboardStackString.dashboard}
        screenOptions={{
          headerBackTitleVisible: false,
          headerMode: 'screen',
          headerShown: renderTabBarIfSmallScreen ? true : false,
          gestureEnabled: false,
          ...screenTransition,
        }}>
        <Stack.Screen
          name={DashboardStackString.dashboard}
          options={{ headerShown: isMobile(!renderTabBarIfSmallScreen) ? true : false }}
          initialParams={{
            isLoading: !selectedMname || !loadInitialsHandler.state || loadInitialsHandler?.state === 'pending',
            initialRoute: initialRoute,
            ...params,
          }}>
          {(props) => (
            <DashboardComponent
              {...props}
              isLoading={!selectedMname || !loadInitialsHandler.state || loadInitialsHandler?.state === 'pending'}
            />
          )}
        </Stack.Screen>
        <Stack.Screen
          name={DashboardStackString.search}
          component={Search}
          options={{
            headerShown: false,
          }}
        />

        {/* <Stack.Screen name="enterAmountForQr" component={EnterAmount} options={{ headerShown: false }} />
        <Stack.Screen name="generateQR" component={GenerateQR} options={{ headerShown: false }} />
        <Stack.Screen name="qrPaymentStatus" component={QrPaymentStatus} options={{ headerShown: false }} /> */}
        <Stack.Screen name={DashboardStackString.video} component={VideoView} options={{ headerShown: false }} />
        <Stack.Screen name={Routes.NOTIFICATION_SETTINGS} component={ManageNotifications} />
        <Stack.Screen
          name={Routes.BANKACCOUNT}
          component={SettlementBankAccount}
          options={{ headerShown: true, headerShadowVisible: false }}
        />

        <Stack.Screen
          name={Routes.VOICEBOX}
          component={VoiceBox}
          options={{ headerShown: true, headerShadowVisible: false }}
        />
        <Stack.Screen
          name={Routes.USER_MANAGEMENT.MANAGE_USERS}
          key={Routes.USER_MANAGEMENT.MANAGE_USERS}
          component={UserManagment}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name={Routes.RENTAL_HISTORY}
          component={RentalHistory}
          options={{
            headerShown: true,
            headerShadowVisible: false,
          }}
        />

        {renderTabBarIfSmallScreen && (
          <>
            <Stack.Screen
              name={Routes.TRANSACTIONS_DETAILS}
              component={TxnDetails}
              options={{ headerShown: true, headerShadowVisible: false }}
            />
          </>
        )}
        {renderTabBarIfSmallScreen && (
          <>
            <Stack.Screen
              name={Routes.SETTLEMENT_DETAILS}
              component={SettlementDetails}
              options={{ headerShown: true, headerShadowVisible: false }}
            />
            <Stack.Screen name="enterAmountForQr" component={EnterAmount} options={{ headerShown: false }} />
            <Stack.Screen name="generateQR" component={GenerateQR} options={{ headerShown: false }} />
            <Stack.Screen name="qrPaymentStatus" component={QrPaymentStatus} options={{ headerShown: false }} />
            <Stack.Screen name="kycConsentScreen" component={KYCConsentScreen} options={{ headerShown: false }} />
          </>
        )}
        {isOsMobile() && (
          <Stack.Screen name={Routes.BILL_PAYMENTS} component={BillPaymentStack} options={{ headerShown: false }} />
        )}
        <Stack.Screen
          name={Routes.SUPPORT}
          component={Support}
          options={{ headerShown: true, headerShadowVisible: false }}
        />
      </Stack.Navigator>
      <ModalDialogNew
        show={showMidList}
        animate={mobileView ? true : false}
        type={mobileView ? 'bottom' : 'centeredWrap'}
        onDismiss={() => setMidListVisible(false)}
        backgroundColor="TRANSPARENT">
        <Box borderTopLeftRadius={24} borderTopRightRadius={24} bg="WHITE" overflow={'hidden'} pv={32} pb={10}>
          <Box ph={24} flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={22}>
            <Box width={'90%'}>
              <Text fontFamily="JioType-Black" fontSize={24}>
                {mobileView ? 'Switch Account' : 'Select Account'}
              </Text>
            </Box>
            <Box testID="close-midlist" onPress={() => setMidListVisible(false)} underlayColor={'TRANSPARENT'}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>

          <RenderMidList setMidListVisible={setMidListVisible} merchantList={merchantList} mobileView={mobileView} />
        </Box>
      </ModalDialogNew>
    </Box>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: 'auto',
  },
})

export default Dashboard
